import { ProductItem } from '@/features/common/components/Overview/parts/ProductItem/types'
import { PriceItem } from '@/features/common/components/Overview/types'

export const mapProductItemsToPriceItems = (productItems: ProductItem[]) => {
    const productPriceItems: PriceItem[] = productItems.map((item) => ({
        label: `${item.name} ×${item.quantity}`,
        price: item.price,
    }))

    return productPriceItems
}
